import Grid from '../../components/Grid';
import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import UsuarioService from '../../services/usuario_service.js';
import ChangePass from '../../components/change_user_pass/admin_change_user_pass.vue';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const usuarioService = new UsuarioService();

let _this;
export default {
	name: 'Usuarios',
	components: { Grid, ChangePass},
	data: function() {
		return {
			titulo: 'USUARIOS',
			loginService: loginService,
			searchQuery: '',
			submited: false,
			modalChangePass: {},
			data: [],
			actions: [{
				icon: 'pencil',
				name: 'Editar',
				actionBtn: this.editar,
				buttonClass: 'btn btn-xs btn-secondary',
				hide: function() { return true }
			},{
				icon: 'times',
				name: 'Desactivar',
				actionBtn: this.desactivar,
				buttonClass: 'btn btn-xs btn-danger',
				hide: function(item) { return item.activoTag == 'SI' }
			},{
				icon: 'check-circle',
				name: 'Activar',
				actionBtn: this.activar,
				buttonClass: 'btn btn-xs btn-info',
				hide: function(item) { return item.activoTag == 'NO' }
			}, {
				icon: 'lock',
				name: 'Cambiar password',
				actionBtn: this.cambiarPassword,
				buttonClass: 'btn btn-xs btn-warning',
				hide: function() { return true }
			}],
			columns: [
				{key: 'idUser', value: 'Id'},
				{key: 'name', value: 'Nombre'},
				{key: 'lastName', value: 'Apellido'},
				{key: 'uName', value: 'Usuario'},
				{key: 'emailUser', value: 'Email'},
				//{key: 'activoUser', value: 'Activo'},
			] 
		} 
	}, 
	created: function () {
		this.submited = false;
		_this = this;
		if(!loginService.esAdministrador()) {
			routeService.goToHome();
			return;
		}
		this.getData();
	}, 
	methods: { 
		getData: function () {
			usuarioService.get({}).then(function(response) {
				_this.data = [];
				if(response.body == null) {
					alertService.showAlert('danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert('danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.data.push({
							idUser: value.idUser,
							name: value.name,
							lastName: value.lastName,
							dni: value.dni,
							uName: value.uName,
							emailUser: value.emailUser,							
							activoUser: value.activoUser == 1 ? 'SI' : 'NO',
							rol: value.rol
						}); 
					} 
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error);
				return;
			});
		},
		async desactivar(item) {
			try {
				if(!loginService.esAdministrador()) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm('warning', 'Confirmar', '¿Esta seguro que desea desactivar el registro id: ' + item.idTag + '?');
				if(conf) {
					_this.submited = true;
					usuarioService.remove({id: item.idTag}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoTag = 'NO';
							alertService.showAlert('success', 'Confirmación!', 'Registro desactivado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		async activar(item) {
			try {
				if(!loginService.esAdministrador()) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm('warning', 'Confirmar', '¿Esta seguro que desea activar el registro id: ' + item.idTag + '?');
				if(conf) {
					_this.submited = true;
					usuarioService.activate({id: item.idTag}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoTag = 'SI';
							alertService.showAlert('success', 'Confirmación!', 'Registro activado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		agregar: function () {
			if(!loginService.esAdministrador()) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('usuario');
		},
		editar: function (item) {
			if(!loginService.esAdministrador()) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('usuario/' + item.idUser);
		},
		cambiarPassword(item) {
			_this.modalChangePass = item;
			this.$bvModal.show('change-pass');
		}
	}
}

